<template>
    <Card>
        <div class="card-content">
            <div class="chart-normal" ref="chart" style="padding-top: 20px">
                <el-tabs style="height: 100%">
                    <el-tab-pane label="楼层排行">
                        <el-table :data="dataList1" stripe style="width: 100%">
                            <el-table-column prop="Name" label="名称" sortable> </el-table-column>
                            <el-table-column prop="DataIn" label="客流量 (人次)" sortable>
                                <template v-slot="scope">
                                    {{ scope.row.DataIn }}
                                    <div class="progress">
                                        <div :style="getStyle(scope.row.DataIn, maxData.DataIn1)"></div>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="FlowDensity" label="集客力 (人/㎡)" sortable>
                                <template v-slot="scope">
                                    {{ scope.row.FlowDensity }}
                                    <div class="progress">
                                        <div :style="getStyle(scope.row.FlowDensity, maxData.FlowDensity1)"></div>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="Amount" label="销售额 (元)" sortable>
                                <template v-slot="scope">
                                    {{ scope.row.Amount }}
                                    <div class="progress">
                                        <div :style="getStyle(scope.row.Amount, maxData.Amount1)"></div>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                    <el-tab-pane label="店铺排行">
                        <el-table :data="dataList2" stripe style="width: 100%">
                            <el-table-column prop="Name" label="名称" sortable> </el-table-column>
                            <el-table-column prop="DataIn" label="客流量 (人次)" sortable>
                                <template v-slot="scope">
                                    {{ scope.row.DataIn }}
                                    <div class="progress">
                                        <div :style="getStyle(scope.row.DataIn, maxData.DataIn2)"></div>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="FlowDensity" label="集客力 (人/㎡)" sortable>
                                <template v-slot="scope">
                                    {{ scope.row.FlowDensity }}
                                    <div class="progress">
                                        <div :style="getStyle(scope.row.FlowDensity, maxData.FlowDensity2)"></div>
                                    </div> </template
                            ></el-table-column>
                            <el-table-column prop="Amount" label="销售额 (元)" sortable>
                                <template v-slot="scope">
                                    {{ scope.row.Amount }}
                                    <div class="progress">
                                        <div :style="getStyle(scope.row.Amount, maxData.Amount2)"></div>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                    <el-tab-pane label="出入口排行">
                        <el-table :data="dataList3" stripe style="width: 100%">
                            <el-table-column prop="Name" label="名称" sortable> </el-table-column>
                            <el-table-column prop="DataIn" label="客流量 (人次)" sortable>
                                <template v-slot="scope">
                                    {{ scope.row.DataIn }}
                                    <div class="progress">
                                        <div :style="getStyle(scope.row.DataIn, maxData.DataIn3)"></div>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
    </Card>
</template>
<script>
import * as echarts from "echarts";
export default {
    name: "FlowRank",
    data() {
        return {
            dataList1: [],
            dataList2: [],
            dataList3: [],
            maxData: {
                DataIn1: 0,
                FlowDensity1: 0,
                Amount1: 0,
                DataIn2: 0,
                FlowDensity2: 0,
                Amount2: 0,
                DataIn3: 0,
            },
        };
    },
    mounted() {},
    methods: {
        setData(data) {
            data.EntityID = data.ID;
            data.EndTime = data.BeginTime;
            data.Date = data.BeginTime;

            this.$ajax.post("/AnalyzeData/GetFloorRank", data).then((result) => {
                this.dataList1 = result.Data;
                for (let i = 0; i < this.dataList1.length; i++) {
                    this.maxData.DataIn1 = Math.max(this.maxData.DataIn1, this.dataList1[i].DataIn);
                    this.maxData.FlowDensity1 = Math.max(this.maxData.FlowDensity1, this.dataList1[i].FlowDensity);
                    this.maxData.Amount1 = Math.max(this.maxData.Amount1, this.dataList1[i].Amount);
                }
            });
            this.$ajax.post("/AnalyzeData/GetShopRank", data).then((result) => {
                this.dataList2 = result.Data;
                for (let i = 0; i < this.dataList2.length; i++) {
                    this.maxData.DataIn2 = Math.max(this.maxData.DataIn2, this.dataList2[i].DataIn);
                    this.maxData.FlowDensity2 = Math.max(this.maxData.FlowDensity2, this.dataList2[i].FlowDensity);
                    this.maxData.Amount2 = Math.max(this.maxData.Amount2, this.dataList2[i].Amount);
                }
            });
            this.$ajax.post("/AnalyzeData/GetDoorRank", data).then((result) => {
                this.dataList3 = result.Data;
                for (let i = 0; i < this.dataList3.length; i++) {
                    this.maxData.DataIn3 = Math.max(this.maxData.DataIn3, this.dataList3[i].DataIn);
                }
            });
        },
        getStyle(d1, d2) {
            let wd = 0;
            if (d2 != 0) {
                wd = (d1 * 100) / d2;
            }
            return {
                width: wd + "%",
            };
        },
        getOptions() {},
    },
};
</script>
<style scoped>
.progress {
    height: 10px;
    width: 60%;
    display: inline-block;
    margin-left: 20px;
}
.progress div {
    height: 10px;
    border-radius: 5px;
    float: left;
    display: inline;
    background-color: #4099f5;
}
</style>
